export const PROGRAM_BENEFITS_6_CONSTANTS = {
  // Friendly titles for the two metadata tables rendered in the admin form.
  METADATA_TITLES: {
    metadata: "Fee Plans",
    metadata_1: "Certificates",
  },

  // `metadata` → one row per fee plan. A single row renders without a toggle;
  // two or more rows render a pill toggle (using each row's plan label) that
  // switches the whole fee card.
  DEFAULT_ROW: {
    id: "1",
    meta_priority: "1",
    meta_plan_label: "Regular",
    meta_student_type: "For Indian Students",
    meta_scholarship_note:
      "Scholarships worth up to ₹50,000 available for early applicants.",
    meta_emi_image: "",
    meta_emi_image_alt: "No Cost EMI",
    meta_emi_prefix_label: "Starts at Just",
    meta_emi_amount: "Rs 6,031/-",
    meta_total_fee_label: "Total Fee",
    meta_markup_fee: "₹2,50,000",
    meta_total_fee_amount: "₹1,77,000",
    meta_semester_label: "Per Semester",
    meta_semester_amount: "₹29,500",
    meta_annual_label: "Per Annum",
    meta_annual_amount: "₹59,000",
    meta_other_fees:
      "Fees are inclusive of all taxes.\nEMI amount is indicative; final terms decided by the partner NBFC.",
    meta_eligibility:
      "Eligibility: Candidates must have completed 10+2 from a recognised board.",
    meta_cta_url: "",
  },

  // `metadata_1` → repeating certificate rows. Rows that share the same
  // accordion title are grouped into one accordion item whose images form a
  // carousel.
  DEFAULT_ROW_1: {
    id: "1",
    meta_priority: "1",
    meta_plan_label: "",
    meta_accordion_title:
      "Earn a globally benchmarked Harvard Business School Publishing certificate.",
    meta_cert_image: "",
    meta_cert_alt: "Certificate",
  },

  PROGRAM_BENEFITS_6_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title (wrap a phrase in { } to highlight it)",
      value: "Fee Structure {& Scholarships}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Fee Structure {& Scholarships}",
      required: true,
      defaultValue: "Fee Structure {& Scholarships}",
    },
    {
      fieldName: "title_start_color",
      label: "Title color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "title_end_color",
      label: "Title highlight color (the { } phrase)",
      value: "#E15518",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E15518",
      required: false,
      defaultValue: "#E15518",
    },
    {
      fieldName: "subtitle",
      label: "Description (below title)",
      value:
        "Flexible payment options and zero cost EMIs make your programme even more accessible.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Supporting line",
      required: false,
      defaultValue:
        "Flexible payment options and zero cost EMIs make your programme even more accessible.",
    },
    {
      fieldName: "subtitle_color",
      label: "Description text color",
      value: "#373737",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#373737",
      required: false,
      defaultValue: "#373737",
    },
    {
      fieldName: "button_text",
      label: "CTA label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Apply Now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_color",
      label: "CTA / amount-box background",
      value: "#EF4444",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#EF4444",
      required: false,
      defaultValue: "#EF4444",
    },
    {
      fieldName: "button_text_color",
      label: "CTA text",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_is_cta",
      label: "Is CTA — Apply (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup; off = direct CTA URL from the Fee Plan table",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "card_hover_background_color",
      label: "Per Semester / Per Annum box color",
      value: "#EF4444",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#EF4444",
      required: false,
      defaultValue: "#EF4444",
    },
    {
      fieldName: "gradient_color_1",
      label: "Fee card — gradient start",
      value: "#1D1D1F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#1D1D1F",
      required: false,
      defaultValue: "#1D1D1F",
    },
    {
      fieldName: "gradient_color_2",
      label: "Fee card — gradient end",
      value: "#B5460A",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#B5460A",
      required: false,
      defaultValue: "#B5460A",
    },
    {
      fieldName: "pre_title",
      label: "Certificates — heading (leave blank to hide section)",
      value: "Prestigious Industry Certifications",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Prestigious Industry Certifications",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description",
      label: "Certificates — subheading",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Optional supporting line",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: false,
    },
  ],

  // Fee Plans — one row per toggle tab (a single row hides the toggle).
  METADATA_FIELDS: [
    {
      header: "Plan label (toggle tab — shown only when 2+ plans exist)",
      fieldName: "meta_plan_label",
      value: "Regular",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Regular / Integrated",
    },
    {
      header: "Student type line (below CTA)",
      fieldName: "meta_student_type",
      value: "For Indian Students",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "For Indian Students",
    },
    {
      header: "Scholarship note (animated gradient line)",
      fieldName: "meta_scholarship_note",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Scholarships worth up to ₹50,000…",
    },
    {
      header: "No-Cost-EMI badge image (leave blank to hide)",
      fieldName: "meta_emi_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload the 'No Cost EMI' badge",
    },
    {
      header: "EMI badge — alt text",
      fieldName: "meta_emi_image_alt",
      value: "No Cost EMI",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "No Cost EMI",
    },
    {
      header: "EMI prefix label (leave blank to hide EMI line)",
      fieldName: "meta_emi_prefix_label",
      value: "Starts at Just",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Starts at Just",
    },
    {
      header: "EMI amount (leave blank to hide EMI line)",
      fieldName: "meta_emi_amount",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Rs 6,031/-",
    },
    {
      header: "Total fee — label",
      fieldName: "meta_total_fee_label",
      value: "Total Fee",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Total Fee",
    },
    {
      header: "Markup fee (struck-through, optional)",
      fieldName: "meta_markup_fee",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "₹2,50,000",
    },
    {
      header: "Total fee — amount",
      fieldName: "meta_total_fee_amount",
      value: "₹1,77,000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "₹1,77,000",
    },
    {
      header: "Per Semester — label",
      fieldName: "meta_semester_label",
      value: "Per Semester",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Per Semester",
    },
    {
      header: "Per Semester — amount",
      fieldName: "meta_semester_amount",
      value: "₹29,500",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "₹29,500",
    },
    {
      header: "Per Annum — label",
      fieldName: "meta_annual_label",
      value: "Per Annum",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Per Annum",
    },
    {
      header: "Per Annum — amount",
      fieldName: "meta_annual_amount",
      value: "₹59,000",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "₹59,000",
    },
    {
      header: "Fee notes (one per line; wrap a phrase in { } to highlight)",
      fieldName: "meta_other_fees",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Fees inclusive of taxes.\n{No-cost EMI} available.",
    },
    {
      header: "Eligibility callout (rich text — bold, bullet lists)",
      fieldName: "meta_eligibility",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Eligibility: …",
    },
    {
      header: "CTA URL (used when Is CTA is off)",
      fieldName: "meta_cta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://…",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "1",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "1",
      required: true,
    },
  ],

  // Certificates — repeating rows. Rows sharing an accordion title group into
  // one accordion item; their images form that item's carousel.
  METADATA_FIELDS_1: [
    {
      header: "Plan label (match a Fee Plan tab; blank = show on all tabs)",
      fieldName: "meta_plan_label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Integrated (leave blank for all plans)",
    },
    {
      header: "Accordion title (rows with the same title are grouped)",
      fieldName: "meta_accordion_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Earn a Harvard Business Publishing certificate…",
      required: false,
    },
    {
      header: "Certificate image",
      fieldName: "meta_cert_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload certificate image",
    },
    {
      header: "Certificate image — alt text",
      fieldName: "meta_cert_alt",
      value: "Certificate",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Certificate",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "1",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "1",
      required: true,
    },
  ],
};
